const createDebug = require('debug');

module.exports = createDebug('mtproto-core');
